// React-Screen CInfoMode ("Infos zum aktuellen Stand") - Strangler Phase 5,
// Klasse A. Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle infomode.js (aus
// lib/scripts/pos/components/CMP_CInfoMode.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CInfoMode.html, gezogen aus
// tests/visual-baseline/22-info-kassendaten.html.
//
// Eigenes Layout LYT_infoMode.xml (eine CFrame-Karte ueber dem Login-Schirm)
// statt LYT_bonOverlay. Erreichbar nur ueber den kleinen "i"-Knopf des
// Login-Schirms (CLoginScreen.info).
//
// FALLE: dieser Screen hat KEINE eigene Wurzel-Klasse. Der Legacy-
// Konstruktor ruft construct(id, session) - bei addChild(CInfoMode) ist der
// zweite Parameter undefined, die Wurzel heisst deshalb schlicht
// "CComponent". Darum spec.addclass weglassen (und in der Galerie auf den
// Text warten, nicht auf eine Klasse).
//
// Die Werte baut Legacy einmal in prepare() zusammen (buildLabels/buildData)
// und gibt sie als properties.value in den Builder - Klasse UND innerHTML
// tragen also denselben String. Genau deshalb wird hier ebenfalls in
// prepare() gerechnet und nicht beim Rendern: die Uhrzeit soll sich zwischen
// Klasse und Text nicht unterscheiden koennen.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';

// Legacy-CCaption: innerHTML = value UND class = "CCaption <value>".
function Caption({ bridge, path, value, style }) {
  return <p {...bridge.el(path, 'CCaption')} className={'CCaption ' + value} style={style}
            dangerouslySetInnerHTML={{ __html: value }} />;
}

const LABELS = ['VERSION', 'POS_ID', 'DRAWER', 'LOGGED_IN_USERS', 'POS_OPENED', 'TIME',
  'CAMERA_IMAGE'];

function buildUsers() {
  let text = '';

  for (var i = 1; i < POS.sessions.openSessions.length; i++) {
    if (typeof POS.sessions.openSessions[i] == 'undefined')
      continue;

    text += POS.sessions.openSessions[i].userProps.Login;

    if (i < POS.sessions.openSessions.length - 1)
      text += ', ';
  }

  if (text == '')
    text = 'keine';

  return text;
}

function buildData() {
  let text = '';

  for (var i in LABELS) {
    switch (LABELS[i]) {
      case 'VERSION':
        text += POS.ProgramVersion;
        break;
      case 'POS_ID':
        text += POS.POSId;
        break;
      case 'DRAWER':
        if (POS.Cashbox.isDrawerOpen())
          text += 'offen';
        else
          text += 'zu';
        break;
      case 'LOGGED_IN_USERS':
        text += buildUsers();
        break;
      case 'POS_OPENED':
        if (POS.isPOSOpened)
          text += 'ja';
        else
          text += 'nein';
        break;
      case 'TIME':
        var d = new Date();
        var minutes = d.getMinutes();
        var hours = d.getHours();
        text += expandInteger(hours, 2) + ':' + expandInteger(minutes, 2);
        break;
    }

    text += "<div style='margin:10px'></div>";
  }

  return text;
}

function buildLabels() {
  let text = '';

  for (var i in LABELS)
    text += POS.lang.getText('LABELS', LABELS[i]) + ": <div style='margin:10px'></div>";

  return text;
}

function InfoModeScreen({ bridge }) {
  const t = bridge.t;
  // Legacy: closeButton.properties.events.onMousedown = this.close
  const closeButton = bridge.widget('0:4', 'CPushButton', {
    events: { onMousedown: () => bridge.removeMe(), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });

  return (
    <>
      {/* infoWindow */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame"
           style={{ position: 'absolute', top: '16.25%', left: '15.23%', borderStyle: 'solid',
                    borderWidth: '1px', height: '59%', width: '41%' }}>
        {/* title */}
        <Caption bridge={bridge} path="0:0" value={t('LABELS', 'INFO_CURRENT_POS')}
                 style={{ position: 'absolute', left: '14px', top: '13px', fontSize: '24px',
                          fontWeight: 'bold' }} />
        {/* labels */}
        <Caption bridge={bridge} path="0:1" value={bridge.state.labels}
                 style={{ position: 'absolute', left: '14px', top: '80px', width: '336px',
                          fontSize: '22px', fontWeight: 'normal' }} />
        {/* data */}
        <Caption bridge={bridge} path="0:2" value={bridge.state.data}
                 style={{ position: 'absolute', left: '340px', top: '80px', width: '336px',
                          fontSize: '22px', fontWeight: 'bold' }} />
        {/* cameraImage - src aus POS.EnvProperties["SCREENSAVERIMAGE"] */}
        <img {...bridge.el('0:3', 'CImage')} className="CImage" src={bridge.state.cameraSrc}
             style={{ position: 'absolute', top: '300px', left: '340px', width: '200px',
                      height: '130px' }} />
        {/* closeButton */}
        <div {...closeButton} className="CPushButton"
             style={{ position: 'absolute', right: '0px', top: '0px', width: '3vw', height: '5vh',
                      backgroundImage: 'url(lib/img/08_X.png)', backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center' }}>
          <p {...bridge.el('0:4:0', 'CCaption')} className="CCaption undefined"></p>
        </div>
      </div>
    </>
  );
}

export const CInfoMode = defineReactScreen({
  className: 'CInfoMode',
  // KEIN addclass - s. Kopfkommentar (Wurzel bleibt "CComponent").
  htmlType: 'div',
  Screen: InfoModeScreen,
  initialState: { labels: '', data: '', cameraSrc: '' },
  prepare(bridge) {
    // Wurzel-Styles standen im Legacy-Konstruktor; prepare() laeuft vor
    // create(), der Builder schreibt sie also wie bisher ans Wurzelelement.
    // (properties.defaultFocus = null aus dem Legacy-Konstruktor liest
    // niemand - weggelassen.)
    bridge.properties.styles = {
      opacity: '0.93',
      position: 'absolute',
      backgroundColor: '#DFDFDF',
      width: '100%',
      height: '100%',
      left: '0px',
      top: '0px',
      // NEU (Nutzer-OK 21.8.2026), kein Legacy-Wert: ohne zIndex war der
      // Schliessen-Knopf NICHT anklickbar. Grund ist eine zufaellige
      // CSS-Kollision: der Builder schreibt den Wert einer CCaption auch in
      // ihr class-Attribut, die Ueberschrift des Login-Schirms heisst
      // "Benutzer Login" - und damit greift die Regel `.Login { position:
      // absolute; ...; z-index: 1 }` auf diesen ABSATZ. Er lag dadurch mit
      // z-index 1 ueber dem Info-Schirm (z-index auto), obwohl er im DOM
      // frueher steht. Statt die class-aus-Wert-Eigenheit des Builders
      // anzutasten (die haengt an der DOM-Paritaet aller Screens), hebt der
      // Info-Schirm sich hier eine Ebene hoeher.
      zIndex: '2',
    };

    bridge.state.labels = buildLabels();
    bridge.state.data = buildData();
    bridge.state.cameraSrc = POS.EnvProperties['SCREENSAVERIMAGE'];
  },
});
